import { render, staticRenderFns } from "./CreateGroupsManagementTest.vue?vue&type=template&id=0c2a5360&scoped=true"
import script from "./CreateGroupsManagementTest.vue?vue&type=script&lang=js"
export * from "./CreateGroupsManagementTest.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupsManagementTest.vue?vue&type=style&index=0&id=0c2a5360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a5360",
  null
  
)

export default component.exports